import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import MDEditor from '@uiw/react-md-editor';
import LogoNoText from '../../../svg/LogoNoText.js';
import InquirySvg from '../../../svg/student/Inquiry.js';
import LeftArrowSvg from '../../../svg/student/Left.js';
import RightArrowSvg from '../../../svg/student/Right.js';
import PreviousSvg from '../../../svg/student/Previous.js';
import NextSvg from '../../../svg/student/Next.js';
import ReloadSvg from '../../../svg/student/Reload.js';
import Instructions from '../../student/Instructions.js';
import { getDragAndDropScore, getMCQScore, getQuestionScore, getStudentScore, getTableScore, getTimeToComplete, getTotalScore } from '../../../util/mission.js';
import PopupWindow from './TextPopupWindow';
import { adminUpdateStudentMissions, teacherUpdateRemarks } from '../../../services2/pstudentMissions.service.js';
import LoadingPage from '../../components/LoadingPage';
import DropDownMenu from '../../components/DropDownMenu.js';
const dragAndDropWidth = 180
const dragAndDropHeight = 180

function Component(props) {
    const mission = props.mission

    const [isloading, setisLoading] = useState(false)


    const [questionIndex, setquestionIndex] = useState(0);
    const selectQuestion = (item, index) => () => {
        setquestionIndex(index)
    }
    const progress = mission?.progress || 0



    const [tabIndex, settabIndex] = useState(0);

    const [dragSource, setdragSource] = useState(null)

    const handlePreviousQuestion = async () => {
        if (questionIndex === 0) return
        setquestionIndex(questionIndex - 1)
    }

    const handleNextQuestion = async () => {

        if (questionIndex === mission?.questions?.length - 1) {
            return
        }
        setquestionIndex(questionIndex + 1)
    }

    const isDraggable = (optionIndex) => {
        for (let column of mission?.questions[questionIndex]?.dragAndDrop) {
            for (let row of column?.rows) {
                if (row.studentAnswer === mission?.questions[questionIndex]?.dragAndDropOptions?.[optionIndex]?.text) {
                    return false
                }
            }
        }
        return true
    }
    {/*handle popup window*/ }
    const [isShowPopup, setisShowPopup] = useState(false)

    const [isShowInstruction, setisShowInstruction] = useState(false)
    const [isShowRemarksPopup, setisShowRemarksPopup] = useState(null)

    const handleUpdateRemarks = async () => {
        setisLoading(true)
        let result = await teacherUpdateRemarks(props.token.token, mission._id, isShowRemarksPopup)
        if (result.errno) {
            alert(result.message || 'Error')
        } else {
            if (props.refresh) {
                props.refresh()
                setisShowRemarksPopup(null)
            }
            alert('儲存成功')
        }
        setisLoading(false)
    }
    const handleUpdateScore = (q, qi, score, is888 = false, is999 = false) => async () => {
        setisLoading(true)
        let questions = [...mission.questions]
        questions[qi] = { ...q, markingScore: score, markingTime: new Date(), is888, is999 }
        let result = await adminUpdateStudentMissions(props.token.token, mission._id, {
            questions,
        })
        if (result.errno) {
            alert(JSON.stringify(result.message) || 'Error')
        } else {
            if (props.refresh) {
                props.refresh()
            }
        }
        setisLoading(false)
    }

    function getQuestionIndex(index){
        let questionIndex = 1
        for (let i = 0; i < index; i++) {
            if (['選擇網頁', '選擇題', '短句作答題', '選擇題 + 短句作答題', '表格問題', '拖放式問題', '拉選題'].includes(mission?.questions[i]?.type)) {
                questionIndex++
            }
        }
        return questionIndex
    }

    return (
        <div className='relative h-full min-h-[800px] min-w-[1024px] flex-1 bg-[#F2F2F2] flex-col flex text-[16px] text-[black]' style={{ overflowY: "auto" }}>

            <div className='w-full flex flex-row items-center justify-start items-center gap-[8px] flex-wrap p-[16px] font-[700]'>
                <div className='flex-1 min-w-[300px]'>閲讀任務名稱: {mission?.name}</div>
                <div className='flex-1 min-w-[300px]'>學校名稱: {mission?.school?.name}</div>
                <div className='flex-1 min-w-[300px]'>學生姓名: {mission?.student?.name}</div>
                <div className='flex-1 min-w-[300px]'>學生班級: {mission?.student?.class}</div>
                <div className='flex-1 min-w-[300px]'>學生性別: {mission?.student?.gender}</div>
                <div className='flex-1 min-w-[300px]'>開始時間: {mission?.startTime ? new Date(mission.startTime).toLocaleString() : ''}</div>
                <div className='flex-1 min-w-[300px]'>完成時間: {mission?.finishTime ? new Date(mission.finishTime).toLocaleString() : ''}</div>
                <div className='flex-1 min-w-[300px]'>回答時間（分:秒）: {getTimeToComplete(mission)}</div>
                <div className='flex-1 min-w-[300px]'>任務狀態: {mission?.status}</div>
                <div className='flex-1 min-w-[300px]'>分數: {getStudentScore(mission?.questions)}/{getTotalScore(mission?.questions)}</div>
                <div className='flex-[2] min-w-[300px] flex flex-row justify-between items-center'>
                    老師評語: {mission?.remarks || ''}
                    {props.token?.usertype === 'p-teacher' && <button className='ml-[16px] text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }} onClick={() => { setisShowRemarksPopup(mission?.remarks || '') }} >
                        編輯評語
                    </button>}
                </div>
            </div>
            {/*header*/}
            <div className='h-[65px] w-full flex flex-row justify-between items-center gap-[16px] bg-[black] px-[24px] flex-wrap'>
                <div className='flex-1 flex flex-row justify-start items-center gap-[24px]'>
                    <div className='flex flex-row'>
                        {mission?.questions?.map((item, index) =>
                            !['選擇網頁', '選擇題', '短句作答題', '選擇題 + 短句作答題', '表格問題', '拖放式問題', '拉選題'].includes(item.type)
                                ? <div key={item?.id || index} />
                                : <div
                                    onClick={selectQuestion(item, index)} key={item?.id || index}
                                    className='h-[36px] w-[50px] cursor-pointer flex flex-row justify-center items-center font-[700] rounded-[12px] mr-[4px]'
                                    style={{
                                        backgroundColor: index === questionIndex ? 'rgb(0,166,220)' : index <= progress ? 'rgb(0,166,220)' : '#aaa',
                                        color: index === questionIndex ? 'white' : getQuestionScore(item) === item?.score ? 'rgb(50,255,200)' : 'rgb(255,30,100)'
                                    }}
                                >
                                    <div className='text-black'>{getQuestionIndex(index)}.</div>{getQuestionScore(item)}/{item?.score || "0"}
                                </div>
                        )}
                    </div>
                </div>
                <div className='text-[32px] font-[700] text-[#1F4CC8]' style={{ display: 'flex' }}>
                    <LogoNoText width={'90px'} />
                </div>
            </div>
            {/*end of header*/}

            {/*content*/}
            <div className='flex flex-row w-full flex-1 bg-[#D9D9D9]' style={{ overflow: 'hidden' }}>
                {/*webpages*/}
                <div className='flex flex-col w-full bg-[white]' style={{ border: '2px solid black', padding: 10 }}>
                    {/*tabs*/}
                    <div className='flex flex-row w-full items-end justify-start bg-[white]' style={{ border: '2px solid black', paddingLeft: 16, paddingRight: 16, gap: 8, paddingTop: 6 }} >
                        {mission?.questions?.[questionIndex]?.type === '選擇網頁'
                            ? <div className='flex flex-row items-center gap-[8px] px-[12px] py-[4px] cursor-pointer hover:opacity-[.7] mb-[-2px]' style={{ backgroundColor: '#EEF2F6', borderTop: '2px solid black', borderLeft: '2px solid black', borderRight: '2px solid black', borderBottom: '2px solid #EEF2F6' }}>
                                <div className='font-[900]' style={{ color: 'black', fontSize: 16 }}>Google Search</div>
                            </div>
                            : mission?.pages?.map((page, index) =>
                                page?.initial ?
                                    <div onClick={() => { settabIndex(index) }} key={page.id || index} className='flex flex-row items-center gap-[8px] px-[12px] py-[4px] cursor-pointer hover:opacity-[.7] mb-[-2px]' style={{ backgroundColor: tabIndex === index ? '#EEF2F6' : 'white', borderTop: '2px solid black', borderLeft: '2px solid black', borderRight: '2px solid black', borderBottom: tabIndex === index ? '2px solid #EEF2F6' : '2px solid white' }}>
                                        <div className='font-[900]' style={{ color: tabIndex == index ? 'black' : 'black', fontSize: 16 }}>{page?.name}</div>
                                    </div>
                                    : <div key={page?.id || index} />
                            )}
                    </div>
                    <div className='w-full flex flex-row bg-[white] items-center' style={{ border: '2px solid black', marginTop: 4, marginBottom: 4, gap: 6, padding: 6 }}>
                        <div className='cursor-pointer'>
                            <PreviousSvg height={30} width={30} />
                        </div>
                        <div className='cursor-pointer'>
                            <NextSvg height={30} width={30} />
                        </div>
                        <div className='cursor-pointer'>
                            <ReloadSvg height={30} width={30} />
                        </div>
                        <div className='flex-1'>
                            <input disabled={true} className='w-full text-[black] bg-[#EEF2F6] rounded-[4px]' value={mission?.questions?.[questionIndex]?.type === '選擇網頁' ? 'https://google.com' : mission?.pages?.[tabIndex]?.url || 'xxx.yyy.com'} style={{ fontSize: 16, height: 40, paddingLeft: 24, paddingRight: 24 }} />
                        </div>
                    </div>

                    {/*end tabs*/}

                    {/*web content*/}
                    <div className='flex w-full flex-1 bg-[white]' style={{ overflowY: 'auto', border: '2px solid black' }}>
                        {mission?.questions?.[questionIndex]?.type === '選擇網頁' ?
                            <div className='w-full flex flex-col justify-start items-center p-[32px]'>
                                <div className='w-full flex flex-row items-center justify-start gap-[16px] px-[32px]'>
                                    <img className='w-[100px]' src='/google.png' alt='google logo' />
                                    <div className='flex-1 flex flex-row items-center gap-[16px] py-[8px] px-[24px] justify-between' style={{ border: '2px solid #eee', borderRadius: '99px' }}>
                                        {/* {mission?.name} */}{' '}
                                        <img className='w-[18px]' src='/gspeaker.png' alt='google logo' />
                                    </div>
                                </div>
                                <div className='flex flex-col pl-[48px] w-full'>
                                    {mission?.questions?.[questionIndex]?.options?.map((option, index) =>
                                        <div key={index} className='flex flex-col items-start gap-[4px] mt-[24px]'>
                                            <div className='cursor-pointer text-[blue] hover:opacity-[0.7] underline'>{option.text}</div>
                                            <div className='text-[12px] text-[green]'>{option.url}</div>
                                            <div className='text-[14px] text-[#aaa]'>{option.description}</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            : <div className='w-full flex flex-col h-full overflow-auto' style={mission?.pages?.[tabIndex]?.bg_url ? { backgroundImage: `url(${mission?.pages?.[tabIndex]?.bg_url || ''})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' } : {}}>
                                <div className='w-full flex flex-col relative' style={{}}>
                                    {mission?.pages?.[tabIndex]?.contents?.map((item, index) =>
                                        <div key={index} className='w-full flex flex-col rounded-[7px] gap-[8px]' style={item?.isCustom ? (item?.customStyle || {}) : {}}>
                                            {item?.type?.includes('文章標題') && <div className='flex flex-col w-full gap-[8px]'>
                                                <div className={`px-[16px] font-[700]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: item.type === '文章標題(左對齊)' ? 'left' : item.type === '文章標題(居中對齊)' ? 'center' : 'right' }}>
                                                    <MDEditor.Markdown wrapperElement={{ "data-color-mode": "light" }} source={item?.text || ''} style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent", fontSize: 32 }} />
                                                </div>
                                            </div>}
                                            {item?.type?.includes('閱讀文章內容') && <div className='flex flex-col w-full gap-[8px]'>
                                                <div className={`px-[16px]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: item.type === '閱讀文章內容(左對齊)' ? 'left' : item.type === '閱讀文章內容(居中對齊)' ? 'center' : 'right' }}>
                                                    <MDEditor.Markdown wrapperElement={{ "data-color-mode": "light" }} source={item?.text || ''} style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent", fontSize: 20 }} />
                                                </div>
                                            </div>}
                                            {item?.type === '圖片' &&
                                                <div className='w-full flex flex-col'>
                                                    {item?.photo && <div className='relative w-full flex flex-row justify-center p-[16px]' style={{ backgroundColor: item?.backgroundColor || 'white' }}>
                                                        {
                                                            item?.photo
                                                                ? <img style={{ height: 400, width: 400, objectFit: 'contain', maxWidth: '100%' }} src={item?.photo} alt='image' />
                                                                : <div></div>
                                                        }
                                                    </div>}
                                                </div>
                                            }
                                            {item.type === '超連結' && <div className='flex flex-col w-full gap-[8px]'>
                                                <div className={`px-[16px]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: 'left' }}>
                                                    <div cl style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent", fontSize: 20 }}>
                                                        <div className='inline' dangerouslySetInnerHTML={{ __html: (item.redirects?.[0] ? item?.text?.slice(0, item.redirects?.[0]?.start) : item?.text) || '' }} />
                                                        {item.redirects?.sort((a, b) => (a.start > b.start) ? 1 : (a.start < b.start) ? -1 : 0
                                                        )?.map((r, ri) =>
                                                            <div className='inline' key={ri}>
                                                                <div className='inline text-[blue] cursor-pointer underline'
                                                                    onClick={async () => {
                                                                        let newTabIndex = mission?.pages.findIndex(p => p.id == r.pageId)
                                                                        let mission_ = { ...mission }
                                                                        mission_.pages[newTabIndex].initial = true
                                                                        props.setmission(mission_)
                                                                        settabIndex(mission?.pages.findIndex(p => p.id == r.pageId))
                                                                    }}
                                                                    dangerouslySetInnerHTML={{ __html: item?.text.slice(r.start, r.end) }}
                                                                />
                                                                <div className='inline' dangerouslySetInnerHTML={{
                                                                    __html:
                                                                        item.redirects?.[ri + 1] ?
                                                                            item?.text.slice(r.end, item.redirects?.[ri + 1].start)
                                                                            : item?.text.slice(r.end)
                                                                }} />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>}
                                            {item.type === '彈出視窗' && <div className='flex flex-col gap-[8px]'>
                                                <div className={`px-[16px]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: 'left' }}>
                                                    <div cl style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent", fontSize: 20 }}>
                                                        <div className='inline' dangerouslySetInnerHTML={{ __html: (item.popups?.[0] ? item?.text?.slice(0, item.popups?.[0]?.start) : item?.text) || '' }} />
                                                        {item.popups?.sort((a, b) => (a.start > b.start) ? 1 : (a.start < b.start) ? -1 : 0
                                                        )?.map((r, ri) =>
                                                            <div className='inline' key={ri}>
                                                                <div className='inline text-[blue] cursor-pointer' style={{ textDecoration: item.noUnderline ? 'none' : 'underline' }} onClick={() => { setisShowPopup(r.text) }} dangerouslySetInnerHTML={{ __html: item?.text.slice(r.start, r.end) }} />
                                                                <div className='inline' dangerouslySetInnerHTML={{
                                                                    __html:
                                                                        item.popups?.[ri + 1] ?
                                                                            item?.text.slice(r.end, item.redipopupsrects?.[ri + 1].start)
                                                                            : item?.text.slice(r.end)
                                                                }} />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>
                                    )}
                                </div>
                            </div>
                        }
                    </div>
                    {/*end of web content*/}
                </div>

                {/*question*/}
                <div className='flex flex-col h-full bg-[white] justify-start items-start text-[black]' style={{ border: '2px solid black', fontSize: 16, width: 600 }}>
                    <div className='w-full bg-[rgb(176,31,28)] h-[80px]' style={{ borderBottom: '2px solid black' }}>
                        <div className='text-[white] text-[24px] font-[700] flex justify-center items-center h-full'>
                            {mission?.name}
                        </div>
                    </div>


                    <div className='flex-1 w-full flex flex-col gap-[8px]' style={{ overflowY: 'auto' }}>

                        {mission?.questions?.filter((q, qIndex) => qIndex <= progress)?.map((q, qIndex) =>
                            <div
                                key={qIndex}
                                className='w-full flex flex-col p-[8px] cursor-pointer'
                                style={{ border: questionIndex === qIndex ? '8px solid rgb(211,16,39)' : '8px solid transparent', borderRadius: 4, backgroundColor: (!['老師導語', '提示語','選擇網頁'].includes(q.type)) ? 'rgb(213,235,241)' : 'white' }}
                                onClick={() => {
                                    setquestionIndex(qIndex)
                                }}
                            >
                                {['老師導語'].includes(q.type) && <div className='flex flex-row w-full gap-[4px]'>
                                    <div className='h-[70px] w-[70px] bg-[#aaa]' style={{}}>
                                        <img src={'/teacher.jpg'} style={{ width: '100%', height: '100%' }} />
                                    </div>
                                    <div className='flex flex-1 flex-col'>
                                        <div className='text-[rgb(144,24,10)] font-bold text-[18px]'>老師</div>
                                        <div className='flex-1' dangerouslySetInnerHTML={{
                                            __html: q?.dialog || ''
                                        }} />
                                    </div>
                                </div>}
                                {['提示語'].includes(q.type) && <div className='flex flex-row w-full gap-[4px]'>
                                    <div className='h-[30px] w-[30px]' style={{}}>
                                        <img src='/hint.png' style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                    </div>
                                    <div className='flex flex-1 flex-col'>
                                        <div className='text-[#2089dd] font-bold text-[18px]'>提示</div>
                                        <div className='flex-1' dangerouslySetInnerHTML={{
                                            __html: q?.dialog || ''
                                        }} />
                                    </div>
                                </div>}


                                {['選擇網頁'].includes(q.type) && <div className='w-full flex flex-col'>
                                    <div className='flex flex-row w-full gap-[4px]'>
                                        <div className='h-[70px] w-[70px] bg-[#aaa]' style={{}}>
                                            <img src={'/teacher.jpg'} style={{ width: '100%', height: '100%' }} />
                                        </div>
                                        <div className='flex flex-1 flex-col'>
                                            <div className='text-[rgb(144,24,10)] font-bold text-[18px]'>老師</div>
                                            <div className='flex-1' dangerouslySetInnerHTML={{
                                                __html: q?.dialog || ''
                                            }} />
                                        </div>
                                    </div>
                                    <div className='font-[700]'> 學生回答:  {q?.options?.filter(i => i.isSelected)?.reduce((acc, i) => { return acc + (acc ? ',' : '') + i.text }, '')}</div>
                                    <div className='font-[700]'>正確答案: {q?.options?.filter(i => i.correct)?.reduce((acc, i) => { return acc + (acc ? ',' : '') + i.text }, '')}</div>

                                    <div className='font-[700]'>分數: {getMCQScore(q)}/{q?.score || "0"}</div>
                                </div>}


                                {['選擇題', '選擇題 + 短句作答題', '拉選題'].includes(q?.type) &&
                                    <MDEditor.Markdown source={q?.question || ''} style={{ fontSize: 16, whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent" }} />
                                }
                                {['短句作答題'].includes(q?.type) && <MDEditor.Markdown source={q?.questionShortanswer || ''} style={{ whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent", fontSize: 16 }} />}
                                

                                {!['老師導語', '提示語', '選擇網頁'].includes(q.type) &&
                                    <div className='flex flex-row w-full gap-[4px]'>
                                        <div className='h-[70px] w-[70px] bg-[#aaa]' style={{}}>
                                            <img src={mission.avatar === '1' ? '/female.jpg' : '/male.jpg'} style={{ width: '100%', height: '100%' }} />
                                        </div>
                                        <div className='flex flex-1 flex-col'>
                                            <div className='text-[rgb(144,24,10)] font-bold text-[18px]'>學生</div>
                                            <div className='flex-1' dangerouslySetInnerHTML={{
                                                __html: q?.dialog || ''
                                            }} />
                                        </div>
                                    </div>
                                }



                                {['選擇題', '選擇題 + 短句作答題'].includes(q.type) &&
                                    <div className='w-full mt-[16px] flex flex-col items-start gap-[16px]'>
                                        {q?.options?.map((option, optionIndex) => (
                                            <div key={optionIndex} className='w-full flex flex-col gap-[4px]'>
                                                <div className='flex flex-row gap-[8px] items-center'>
                                                    <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                        <button className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${option.isSelected ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                        ></button>
                                                    </div>
                                                    {option.text}
                                                </div>
                                                <div style={{ borderBottom: '4px dotted #2089dd' }}></div>
                                            </div>
                                        ))}
                                        <div className='font-[700]'>正確答案: {q?.options?.filter(i => i.correct)?.reduce((acc, i) => { return acc + (acc ? '，' : '') + i.text }, '')}</div>
                                        {['選擇題'].includes(q.type) &&
                                            <div className='font-[700]'>分數: {getMCQScore(q)}/{q?.score || "0"}</div>
                                        }
                                    </div>
                                }
                                {['拉選題'].includes(q.type) &&
                                    <div className='w-full mt-[16px] flex flex-col items-start gap-[16px]'>
                                        <DropDownMenu options={q?.options.map(o => o.text)} value={q.options?.find(o => o.isSelected)?.text || '-- 請選擇 --'} style={{ backgroundColor: 'white' }} select={(item, index) => { }} />
                                        <div className='font-[700]'>正確答案: {q?.options?.filter(i => i.correct)?.reduce((acc, i) => { return acc + i.text }, '')}</div>
                                        <div className='font-[700]'>分數: {getMCQScore(q)}/{q?.score || "0"}</div>
                                    </div>
                                }

                                {['短句作答題', '選擇題 + 短句作答題'].includes(q?.type) && (
                                    <div className='w-fill mt-[16px] flex flex-col p-[2px]'>
                                        {   ['選擇題 + 短句作答題'].includes(q?.type) &&
                                            <MDEditor.Markdown source={q?.questionShortanswer || ''} style={{ whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent", fontSize: 16 }} />
                                        }
                                        <textarea
                                            className='w-full flex flex-col bg-[#F8F8F8] gap-[8px] rounded-[2px] mt-[16px]' style={{ border: '1px solid #00000080', boxShadow: '0px 0px 2px 2px rgb(217,229,193)', padding: 8 }}
                                            value={q?.answer || ''}
                                            disabled={true}
                                        />
                                        {q.hasTwoAnswers && <textarea
                                            className='w-full flex flex-col bg-[#F8F8F8] gap-[8px] rounded-[2px] mt-[16px]' style={{ border: '1px solid #00000080', boxShadow: '0px 0px 2px 2px rgb(217,229,193)', padding: 8 }}
                                            value={q?.answer2 || ''}
                                            disabled={true}
                                        />}
                                        {props.token?.usertype === 'p-admin' && q?.score >= 1 && <div className='font-[700] mt-[8px] flex flex-row items-center flex-wrap justify-start gap-[8px]'>
                                            批改分數:
                                            {Array.from(Array(q?.score + 1).keys())?.map((i) =>
                                                <div onClick={handleUpdateScore(q, qIndex, i)} key={i} className='px-[12px] py-[4px] cursor-pointer rounded-[8px]' style={{
                                                    opacity: (q?.markingScore === i && (!q.is888) && (!q.is999)) ? 1 : .5,
                                                    backgroundColor: (q.markingScore === i && (!q.is888) && (!q.is999)) ? '#1F4CC8' : '#bbb',
                                                    color: (q.markingScore === i && (!q.is888) && (!q.is999)) ? 'white' : 'black'
                                                }}>{i} 分 </div>
                                            )}
                                            <div onClick={handleUpdateScore(q, qIndex, 0, true)} className='px-[12px] py-[4px] cursor-pointer rounded-[8px]' style={{
                                                opacity: q.is888 ? 1 : .5,
                                                backgroundColor: q.is888 ? '#1F4CC8' : '#bbb',
                                                color: q.is888 ? 'white' : 'black'
                                            }
                                            }> 888 </div>
                                            <div onClick={handleUpdateScore(q, qIndex, 0, false, true)} className='px-[12px] py-[4px] cursor-pointer rounded-[8px]' style={{
                                                opacity: q.is999 ? 1 : .5,
                                                backgroundColor: q.is999 ? '#1F4CC8' : '#bbb',
                                                color: q.is999 ? 'white' : 'black'
                                            }}
                                            > 999 </div>
                                        </div>}

                                        <div className='font-[700] mt-[8px]'>分數: {getQuestionScore(q)}/{q?.score || "0"}</div>

                                    </div>
                                )}
                            </div>
                        )}


                    </div>
                </div>
                {/*end of question*/}

            </div>
            {/*end of content*/}

            {isShowPopup && <PopupWindow text={isShowPopup} onClose={() => { setisShowPopup(false) }} />}
            {isShowInstruction && <Instructions close={() => { setisShowInstruction(false) }} />}
            {isShowRemarksPopup !== null && <div className='fixed top-0 left-0 w-full h-full bg-[#00000080] flex justify-center items-center'>
                <div className='bg-white w-[600px] h-[400px] rounded-[7px] p-[16px] flex flex-col gap-[16px]'>
                    <div className='text-[24px] font-[700]'>編輯老師評語</div>
                    <textarea className='w-full h-full border-[1px] border-black rounded-[7px] p-[4px]' value={isShowRemarksPopup || ''} onChange={(e) => { setisShowRemarksPopup(e.target.value) }} />
                    <div className='flex flex-row justify-end items-center gap-[8px]'>
                        <div onClick={() => { setisShowRemarksPopup(null) }} className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>取消</div>
                        <div onClick={handleUpdateRemarks} className='bg-[#1F4CC8] text-white text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>儲存</div>
                    </div>
                </div>
            </div>}
            {isloading && <LoadingPage />}
        </div>
    )

}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
